export default __webpack_public_path__ + "static/24-c90b66946d075977082128909b1659c8.webp";